export default "__VITE_ASSET__$DF8dBv5__"